import { QueryCache, QueryClient } from "@tanstack/react-query";
import { HTTPError } from "ky";
import logger from "./logger";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      const httpError = err as HTTPError;

      logger(httpError.message);
    },
  }),
});

export default queryClient;
